/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskNotificationsInternalNotificationsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskNotificationsInternalNotificationsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { LazyInternalNotificationSettingsPage } from '@jira/servicedesk__notification-internal/src/LazyInternalNotificationSettingsPage.tsx';
import { serviceDeskInternalNotificationsNextGenRedirect } from './ui/service-desk-internal-notifications-next-gen-redirect/index.tsx';
import { LazyProjectSettingsServiceDeskInternalNotifications } from './ui/service-desk-internal-notifications/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry: Route =
	createEntry(
		projectSettingsServicedeskNotificationsInternalNotificationsRoute,

		() => ({
			group: 'project-settings-servicedesk',
			ufoName: 'service-management.internal-notifications',
			// eslint-disable-next-line no-restricted-syntax
			component: serviceDeskInternalNotificationsNextGenRedirect,
			layout: serviceProjectLayout,

			navigation: {
				menuId: MenuIdProjects,
				sidebarId: SidebarIdProjectSettings,
			},

			resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

			forPaint: [
				LazyProjectSettingsServiceDeskInternalNotifications,
				LazyInternalNotificationSettingsPage,
			],

			bifrost: {
				bifrostGroup: 'shell-only',
			},
		}),
	);
